import {ModuleWithProviders, NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {BreadcrumbsComponent} from './breadcrumbs.component'
import {BreadcrumbService} from './breadcrumbs.service'

@NgModule({
  imports: [CommonModule],
  declarations: [BreadcrumbsComponent],
  exports: [BreadcrumbsComponent],
})
export class BreadcrumbsModule {
  static forRoot(): ModuleWithProviders<BreadcrumbsModule> {
    return {
      ngModule: BreadcrumbsModule,
      providers: [BreadcrumbService],
    }
  }
}
